import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Transfer, Button, Card, Modal } from 'antd';

const HatchChooser = forwardRef( ( props, ref ) => {
    const [ targetCelebrationKeys, setTargetCelebrationKeys ] = useState( props.celebrationSelectedKeys );
    const [ deleteModalVisible, setDeleteModalVisible ] = useState( false );
    const [ deleting, setDeleting ] = useState( false );

    useImperativeHandle( ref, () => ( {
        getSelectedKeys() {
            return [ ...targetCelebrationKeys ];
        }
    } ) );

    const handleChangeCelebration = ( nextTargetKeys ) => {
        setTargetCelebrationKeys( nextTargetKeys );
    };

    const filterOption = ( inputValue, option ) => {
        return option.title.toLowerCase().indexOf( inputValue.toLowerCase() ) > -1;
    };

    const deleteCelebrationConfig = async () => {
        const { celebrationConfigId, deleteCelebrationStack, services } = props;
        try {
            setDeleting( true );
            const result = await services.deleteCelebrationConfig( celebrationConfigId );

            // if callback prop was passed in to the hatch, pass the result to the callback
            if ( typeof deleteCelebrationStack === 'function' ) {
                deleteCelebrationStack( celebrationConfigId );
            }
            return result;

        } catch ( error ) {
            console.log( error );
        } finally {
            setDeleting( false );
        }
    };

    const showDeleteModal = () => setDeleteModalVisible( true );
    const handleOkDelete = () => deleteCelebrationConfig();
    const handleCancelDelete = () => setDeleteModalVisible( false );

    return (
        <>
            <Card title="Celebration Configuration">
                <Transfer
                    dataSource={ props.celebrationData }
                    targetKeys={ targetCelebrationKeys }
                    onChange={ ( keys ) => handleChangeCelebration( keys ) }
                    render={ ( item ) => item.title }
                    filterOption={ filterOption }
                    showSearch
                    pagination
                />
                <br />
                { props.celebrationConfigId &&
                    <Button
                        size="large"
                        danger
                        onClick={ showDeleteModal }
                    >
                        Delete
                    </Button>
                }
                <Modal
                    title="Are you sure you want to delete?"
                    visible={ deleteModalVisible }
                    onCancel={ handleCancelDelete }
                    footer={ [
                        <Button key="back" onClick={ handleCancelDelete }>
                            Cancel
                        </Button>,
                        <Button key="delete" danger type="primary" onClick={ handleOkDelete } loading={ deleting }>
                            Delete
                        </Button>
                    ] }
                >
                    <p>All setup with this reward will be deleted. Do you want to continue?</p>
                </Modal>

            </Card>
        </>

    );

} );
export default HatchChooser;
